import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { camelCase } from 'lodash';
import Modal from '../Modal';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';

const ClickTarget = ({ data, onClick, open, opened }) => {
  const styles = {
    left: `${data.x}%`,
    top: `${data.y}%`
  };

  const buttonClasses = classNames(
    {
      'click-and-reveal__target--opened': opened
    },
    'click-and-reveal__target',
    'comet-button',
    'comet-button--primary',
    'comet-button--icon-only'
  );

  const handleClick = () => {
    onClick(camelCase(data.name));
  };

  return (
    <Fragment>
      <button
        className={buttonClasses}
        style={styles}
        onClick={handleClick}
        aria-label="Learn More"
      >
        <svg
          className="comet-button__icon"
          aria-hidden="true"
          focusable="false"
        >
          <use xlinkHref={`${icons}#${opened ? 'check' : 'plus'}`} />
        </svg>
        <span className="comet-screenreader-only">Open Information</span>
      </button>
      {open && <Modal onClose={handleClick} data={data.modal} />}
    </Fragment>
  );
};

ClickTarget.defaultProps = {
  open: false,
  opened: false
};

ClickTarget.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool,
  opened: PropTypes.bool
};

export default ClickTarget;



// WEBPACK FOOTER //
// ../core/src/components/ClickAndReveal/ClickTarget.js